<template>
    <footer class="page-footer">
        <p class="mb-0">Copyright © Neutrix Inc 2023. All right reserved.<br/>
            This Admin Portal is Proprietary Software of Neutrix Inc. & Powered by Neutrix Systems. 
            Any infringement will be handled harshly.
        </p>
    </footer> 
</template>
